'use client';

import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect if the current device is mobile (width < 768px).
 * Centralizes the breakpoint logic to ensure consistency across the app.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
